import React, {useState} from 'react'
import MenuIconsJson from 'json/dashboard/menuIcons'
import {Nav} from 'react-bootstrap'
import NavbarPopUp from './dashcomp/navbar-popup'
import './style.css'

export default function NavIcons() {
    const [state, setState] = useState(false)

    const mouseEnter = (i) => {
        if(state === i) {
            return setState(null)
        }
        setState(i)
    }
    const leaveMouse = () => setState(false)
    return (
        <>
            {
                MenuIconsJson.map((data, i) => {
                    return (
                        <Nav.Link key={i} href={i === 2 ? "cart_page" :null || i === 0 ? "notifikasi" : null}
                        onMouseEnter={() => mouseEnter(i)}
                        onMouseLeave={leaveMouse}
                        >
                            <img style={{cursor: "pointer"}} key={i} src={data.src} alt={data.alt} />
                            {i === 2 ?          
                                <div className="notif-icon-toko">
                                    <p>7</p>
                                </div> : null
                            }
                                {i === 0 ?          
                                    <div className="notif-icon-toko">
                                        <p>3</p>
                                    </div> : null
                                }
                            {
                                state === i ? <>
                                  { i === 2 ? <NavbarPopUp />: null }
                                </> : null
                            }
                        </Nav.Link>
                    )
                })
            }
        </>
    )
}
